// extracted by mini-css-extract-plugin
module.exports = {"hosts":"footer_hosts__oOmNd","partnerLogo":"footer_partnerLogo__HUUU9","container":"footer_container__6D2Nz","section":"footer_section__3YwyF","footer":"footer_footer___AQ3k"};